import $ from "jquery";
import {AssertUtils} from "goingutils";
import {
    _getAccountChange,
    _getAlSelSearchInput,
    _getFilterSelect,
    _getSearchInput
} from "../../../jsCom/goAclDialog/comJs";
import stationTypes, {stationBaseTypes} from "../../../jsCom/goAclDialog/components/stationTypes";
import InitGridObj from "../../../dx/dxInitUtils/initGridObj";

/**
 * 岗位信息加载后 需要判断是否被选中了 如果选中了 则需要打勾当前记录
 * @param cellObj
 * @private
 */
function _afterLoadStationData(cellObj) {
    cellObj.alreadySelGrid.forEachRow(function (id) {
        if (cellObj.stationGrid.getRowIndex(id) >= 0) {
            cellObj.stationGrid.setRowIsSelected(id);
        }
    });
}

export let stationPanelUtils = {
    /**
     * 设置岗位类别的缺省值
     * @param cellObj
     */
    initStationTypeDefVal(cellObj) {
        $(`#${cellObj.tabId}_search_input`).val("所有岗位");
        $(`#${cellObj.tabId}_search_input_val`).val("all");
    },
    /**
     * 添加岗位信息到已选表格中
     * @param cellObj
     * @param rowId
     * @param orgGrid
     * @param dataFrom
     * @private
     */
    _addStationRecordToAlreadyGrid(cellObj, rowId, orgGrid, dataFromLabel) {
        if (!AssertUtils.isNotNull(orgGrid)) {
            orgGrid = cellObj.waitSelGrid;
        }
        let alreadyGrid = cellObj.alreadySelGrid;
        //如果存在已选数据的表格对象
        if (alreadyGrid != null) {
            let dataJson = orgGrid.getRowRecord(rowId);
            //如果不存在 则进行增加 如果存在 则不进行增加
            if (alreadyGrid.getRowIndex(rowId) < 0) {
                alreadyGrid.addRow(rowId, [
                    "",
                    dataJson["name"],
                    dataJson["stationCode"],
                    dataFromLabel,
                    'station'
                ]);
            }
        }
    },
    /**
     * 初始化岗位表格
     * @param cellObj
     * @param moreSel   是否可以多选
     * @param selectRelCheck  是否断开click和checkbox的关联关系
     * @param headerBar 是否显示表头
     */
    initStationGrid(cellObj, moreSel, selectRelCheck, headerBar, colSelBox, clickFun) {
        let colSelType = "checkBox";
        if (cellObj.goTabs["count"] === 1) {
            colSelType = "radioBox";
        }
        let gridConfig = {
            queryUrl: null,
            colOrderNum: true,
            colSelBox: colSelBox,
            colSelType: colSelType,
            hasPagin: false,
            afterLoadData() {
                _afterLoadStationData(cellObj);
            },
            headerBar: headerBar,
            selectRelCheck: selectRelCheck,
            onClick: clickFun,
            moreSel: moreSel,
            fieldAry: [

                {
                    id: "name",
                    required: true,
                    type: "ro",
                    sorting: "str",
                    align: "left",
                    label: "岗位名称",
                    width: "190"
                },
                {
                    id: "typeName",
                    items: stationBaseTypes,
                    required: true,
                    type: "sysCoding_ro",
                    sorting: "str",
                    align: "left",
                    label: "岗位类别",
                    width: "*"
                },
            ]
        };
        //已选数据
        let selGrid = InitGridObj(cellObj.tabId + "_left_top_cell_grid", gridConfig, null);

        //如果可以选择岗位 则需要注册checkBox事件
        if (cellObj.itemConfig["selStation"]) {
            selGrid.attachEvent("onCheck", function (
                rowId,
                cellInd,
                state
            ) {
                //设置checkBoxEvent
                if (state) {
                    cellObj.addStationRecordToAlreadyGrid(rowId, selGrid,"岗位");
                } else {
                    cellObj.delRecordFromAlreadyGrid(rowId);
                }
            });
        }
        selGrid.selAllRecord=function(flag){
            //将所有数据放入到已选
            if(flag){
                selGrid.forEachRow(function (rowId) {
                    cellObj.addLeftTopRecordToAlreadyGrid(rowId,selGrid);
                });
            }else{
                //从已选数据中清空当前列表到数据
                selGrid.forEachRow(function (rowId) {
                    cellObj.delRecordFromAlreadyGrid(rowId);
                });
            }

        };
        return selGrid;
    },
    /**
     * 获取加载岗位表格数据的参数nodeId
     */
    getLoadGridParams(cellObj) {
        let typeName = $("#" + cellObj.tabId + "_search_input_val").val();
        //如果是选择all 则表示查询所有 则设置为空
        if (typeName === "all") {
            typeName = "";
        }
        let backJson = {
            typeCode: typeName,
            name: $(`#${cellObj.tabId}_search_input_text`).val()
        };
        return backJson;
    },
    getStationPanelHeader(cellObj) {
        return `<div class="filter-bar clearfix">
              <div class="tree-sel-drop pull-left">
                 ${_getFilterSelect(375, "选择岗位类型", stationTypes, cellObj.tabId)}
              </div> 
            </div>
            <div class="filter-bar clearfix" style="padding-top: 0">
              <div class="tree-sel-drop pull-left">
                 ${_getAccountChange(175, "请选择账套", cellObj.tabId)}
              </div>
              <div class="search-input pull-left">  
                 ${_getSearchInput(195, "请输入岗位名称", cellObj.tabId)}
              </div> 
            </div>`;
    },
    initRightCellContent(panelHeight, cellObj) {
        let pabelHeight = panelHeight - 40 + "px";
        return `<div>
            <div class="filter-bar clearfix"> 
                    ${cellObj.getSaveToGroup()}  
               <div class="search-input pull-right" style="margin-right: 10px;">  
                   ${_getAlSelSearchInput()}
                </div>
            </div>
             <div class="already-sel-user">
                  <div id="${
            cellObj.tabId
            }_already_sel"  style="height: ${pabelHeight};"></div>
            </div>
         </div>`;
    }
};


export let initStationTypeSelComEvent = function (tabId, selStationTypeFun) {
    //输入框事件
    $("#" + tabId + "_body")
        .find(".search_sel_filter input")
        .focus(function () {
            //显示子项菜单
            $(this)
                .closest(".search_sel_filter")
                .next()
                .show();
        }).click(function () {
        //显示子项菜单
            $(this)
            .closest(".search_sel_filter")
            .next()
            .show();
        });
    //子菜单容器的事件
    $("#" + tabId + "_body")
        .find(".common_sel")
        .mouseover(function () {
            $(this).show();
        })
        .mouseout(function () {
            $(this).hide();
        });

    //子菜单选择事件
    $("#" + tabId + "_body")
        .find(".common_sel .go-drop-item")
        .click(function () {
            $(this)
                .closest(".common_sel")
                .hide();
            $(this)
                .closest(".common_sel")
                .prev()
                .find("input")
                .val($(this).attr("title") + "");
            $(this)
                .closest(".common_sel")
                .prev()
                .find(".input_val")
                .val($(this).attr("val") + "");

            if (AssertUtils.isFunction(selStationTypeFun)) {
                selStationTypeFun();
            }
        });
};



// WEBPACK FOOTER //
// ./goingsrc/jsCom/goAclDialog/components/stationCommon.js